import { useDeletePatientTablePreferencesMutation } from '@common/cache';
import { ConfirmationModal } from 'components/ConfirmationModal';

// type ColumnKey = keyof NonNullable<PatientPreferences['columns']>;

// const COLUMN_KEYS: ColumnKey[] = [
//   'id',
//   'name',
//   'birthdate',
//   'minutes_this_month',
//   'mbi',
//   'account_status',
//   'guide_status',
//   'programs',
//   'provider_name',
//   'practice_name',
//   'care_navigator_name',
//   'building_name',
// ];

// const makeColumnsVisible = (columns?: PatientPreferences['columns']) => {
//   if (!columns) return {};
//
//   return Object.fromEntries(
//     COLUMN_KEYS.map((key, index) => [
//       key,
//       {
//         column_display: 'display',
//         column_size: columns[key]?.column_size ?? 120,
//         column_order: index + 1,
//       },
//     ]),
//   ) as Record<ColumnKey, ColumnPreferencesConfig>;
// };

export const PatientTableResetModal = ({
  isOpen,
  onClose,
  onResetAction,
}: {
  isOpen: boolean;
  onClose: () => void;
  onResetAction?: () => void;
}) => {
  // const { data: preferences } = usePatientTablePreferencesQuery();
  const updatePreferencesMutation = useDeletePatientTablePreferencesMutation();

  // const resetState: PatientPreferences = {
  //   density: 'comfortable',
  //   page_size: 10,
  //   sort_by: 'name',
  //   sort_order: 'ASC',
  //   columns: makeColumnsVisible(preferences?.columns),
  // };

  const handleReset = async () => {
    await updatePreferencesMutation.mutateAsync();
    onResetAction?.();
    onClose();
  };

  return (
    // <Box
    //   sx={{
    //     diplay: 'flex',
    //     whiteSpace: 'nowrap',
    //   }}
    // >
    //   <Button
    //     color='primary'
    //     startIcon={<>{!noStartIcon && <Refresh color='primary' />}</>}
    //     loading={updatePreferencesMutation.isPending}
    //     onClick={handleOpenComplete}
    //   >
    //     {actionText}
    //   </Button>
    //
    //   <ConfirmationModal
    //     title={'Reset table view'}
    //     message={
    //       'This will restore the default columns, sorting, and filters. Your custom layout and pinned columns will be cleared.'
    //     }
    //     closeText='KEEP CURRENT VIEW'
    //     confirmText='RESET VIEW'
    //     onConfirm={handleReset}
    //     onClose={handleCloseComplete}
    //     isOpen={isConfirmModalOpen}
    //     disableCloseOnOutsideClick={false}
    //     isLoading={updatePreferencesMutation.isPending}
    //     reverseButtonOrder
    //   />
    // </Box>

    <ConfirmationModal
      title={'Reset table view'}
      message={
        'This will restore the default columns, sorting, and filters. Your custom layout and pinned columns will be cleared.'
      }
      closeText='KEEP CURRENT VIEW'
      confirmText='RESET VIEW'
      onConfirm={handleReset}
      onClose={onClose}
      isOpen={isOpen}
      disableCloseOnOutsideClick={false}
      isLoading={updatePreferencesMutation.isPending}
      reverseButtonOrder
    />
  );
};
